import { useSelector } from 'react-redux'
import {
    canViewOtherProfiles,
    canViewRoleMatrix,
    canViewTaxonomy,
} from '../../store/selectors/role-selectors'
import React from 'react'
import { ProfilePage } from '../../pages/profile/ProfilePage'
import { SkillsTreePage } from '../../pages/skillsTree/SkillsTreePage'
import { EmployeesSearchPage } from '../../pages/employeesSearch/EmployeesSearchPage'
import { TaxonomyPage } from '../../pages/taxonomy/TaxonomyPage'
import { ChangeRequestsPage } from '../../pages/changeRequests/ChangeRequestsPage'
import { RolesManagementPage } from '../../pages/roles/RolesManagementPage'
import { Navigate, RouteObject } from 'react-router-dom'
import { EmployeesApprovePage } from 'pages/approve/EmployeesApprovePage'
import { authInfo } from 'store/selectors/auth-selectors'

export interface AppRoutesConfigItem extends RouteObject {
    id: string
    label: string
    condition?: () => boolean
    children?: AppRoutesConfigItem[]
}

export const useAppRoutesConfig = (redirectUrl: string) => {
    let hasEmployeesMenuItem = !!useSelector(canViewOtherProfiles)
    let hasTaxonomyMenuItem = !!useSelector(canViewTaxonomy)
    let hasRolesMenuItem = !!useSelector(canViewRoleMatrix)

    const auth = useSelector(authInfo)
    const isAdmin = auth.user?.role === 'adm'

    const routes: AppRoutesConfigItem[] = [
        {
            id: 'Profile',
            label: 'Profile',
            path: 'profile/:id',
            element: <ProfilePage />,
        },
        {
            id: 'Skills',
            label: 'Skills',
            path: 'skills',
            element: <SkillsTreePage />,
        },
        {
            id: 'Employees',
            label: 'Employees',
            path: 'search',
            condition: () => hasEmployeesMenuItem,
            element: <EmployeesSearchPage />,
        },
        {
            id: 'ApproveEmployees',
            label: 'ApproveEmployees',
            path: 'approve-employees',
            //TODO: change to actual action
            condition: () => /*isAdmin*/ !!auth.user?.skills_to_approve,
            element: <EmployeesApprovePage />,
        },
        {
            id: 'Taxonomy',
            label: 'Taxonomy',
            path: 'taxonomy',
            condition: () => hasTaxonomyMenuItem,
            element: <TaxonomyPage />,
        },
        {
            id: 'ChangeRequests',
            label: 'Change Requests',
            path: 'change-requests',
            condition: () => hasTaxonomyMenuItem,
            element: <ChangeRequestsPage />,
        },
        {
            id: 'Roles',
            label: 'Roles',
            path: 'roles',
            condition: () => hasRolesMenuItem,
            element: <RolesManagementPage />,
        },
        {
            id: 'default',
            label: '',
            path: '*',
            element: <Navigate to={redirectUrl} replace />,
        },
    ]

    return {
        routes: routes.filter((item) => item.condition === undefined || item.condition()),
    }
}
